import { Link } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';
import { lightGray, primaryColor, white } from '../../utils/styles';
import { rhythm } from '../../utils/typography';

const CardWrapper = styled.div<{ enabled: boolean }>`
  width: 100%;
  border-radius: 5px;
  transition: box-shadow 0.3s, transform 0.3s;
  box-shadow: 0 2px 2px -1px ${lightGray};
  background-color: ${white};
  margin-bottom: 24px;
  padding: 24px;
  ${({ enabled }) => {
    if (enabled) {
      return `&:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 4px -2px ${lightGray};
      }`;
    } else {
      return `opacity: .5; cursor: not-allowed;`;
    }
  }}
`;

const TopicCardLeft = styled.div`
  display: flex;
  flex-direction: column;
`;
const TopicCardArrow = styled.span`
  color: ${primaryColor};
  line-height: ${rhythm(1)};
  font-size: ${rhythm(1)};
  transform: translateY(-3px);
  font-weight: 700;
`;
const TopicCardTitle = styled.h3`
  margin-top: 0;
  transition: color 0.3s;
`;

const TopicCardContent = styled(Link)`
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  width: 100%;
  outline: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover ${TopicCardTitle} {
    color: ${primaryColor};
  }
`;

type TopicCardProps = {
  title: string;
  url?: string;
};

export const TopicCard: FC<TopicCardProps> = ({ children, title, url, ...rest }) => {
  return (
    <CardWrapper enabled={!!url} {...rest}>
      {url ? (
        <TopicCardContent to={url}>
          <TopicCardLeft>
            <TopicCardTitle>{title}</TopicCardTitle>
            {children}
          </TopicCardLeft>
          <TopicCardArrow>{`>`}</TopicCardArrow>
        </TopicCardContent>
      ) : (
        <div>
          <TopicCardTitle>{title}</TopicCardTitle>
          {children}
        </div>
      )}
    </CardWrapper>
  );
};
